import { CountryInfo } from "@/api/SolarCloudApi";
import { useEnvironmentContext } from "@/contexts/EnvironmentContext";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export default function getGeoCountryQueryOptions(geolocationUrl: string) {
  return queryOptions({
    queryKey: ["geoCountry"],
    queryFn: () => getGeoCountry(geolocationUrl),
    staleTime: Infinity,
  });
}

async function getGeoCountry(geolocationUrl: string) {
  const response = await fetch(geolocationUrl);
  const json = await response.json();

  const country: CountryInfo = {
    code: json.country_code2,
    name: json.country_name,
  };

  return country;
}

type UseGeoCountryOptions = {
  queryConfig?: QueryConfig<typeof getGeoCountryQueryOptions>;
};

export function useGeoCountry({ queryConfig }: UseGeoCountryOptions = {}) {
  const environment = useEnvironmentContext();

  const queryConfigWithEnabled = {
    ...queryConfig,
    enabled: !!environment?.ipgeolocation?.url,
  };

  return useQuery({
    ...getGeoCountryQueryOptions(environment?.ipgeolocation?.url || ""),
    ...queryConfigWithEnabled,
  });
}
